// プレスリリースページから資料ダウンロードする導線を追加する
// https://prtimes.atlassian.net/browse/PRTIMES-2599

const documentDownloadBtn = document.querySelector('.js-document-download');
if (documentDownloadBtn) {
  const closeBtn = documentDownloadBtn.querySelector('.js-document-download-close');
  closeBtn.addEventListener('click', (event) => {
    event.preventDefault();
    documentDownloadBtn.classList.add('hidden');
  });

  document.addEventListener('scroll', () => {
    if (window.pageYOffset > 83) { // header height
      documentDownloadBtn.classList.add('scrolled');
    } else {
      if (documentDownloadBtn.classList.contains('scrolled')) {
        documentDownloadBtn.classList.remove('scrolled');
      }
    }
  });
}
